import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';

@Injectable()
export class BairroProvider {

  private cache: Array<any>;

  constructor(private serverProvider: ServerProvider) {
  }

  public getByName(nome): Observable<any> {
    return Observable.create((observer) => {
      this.get().subscribe(
        (bairros) => {
          let bairro = this.getBairro(bairros, nome);
          observer.next(bairro);
          observer.complete();
        },
        (error) => observer.error(error)
      );
    });
  }

  private getBairro(bairros, nome): any {
    if (!bairros || !nome) {
      return;
    }

    for (let x = 0; x < bairros.length; x++) {
      if (bairros[x].nome.toLowerCase() == nome.toLowerCase()) return bairros[x];
    }
  }

  public get(): Observable<Array<any>> {
    return Observable.create((observer) => {
      if (this.cache) {
        observer.next(this.cache);
        observer.complete();
        return;
      }

      this.loadItems().subscribe(
        (items) => {
          this.cache = [];
          items.forEach((i) => {
            this.cache.push({
              id: i.id,
              nome: i.nome
            });
          });

          observer.next(this.cache);
          observer.complete();
        },
        (error) => observer.error(error)
      );
    });
  }

  public loadItems(): Observable<Array<any>> {
    return Observable.create((observer) => {
      this.serverProvider.postData({ "operacao": "BAIRRO_LISTAR" }).subscribe(
        (data) => {
          if (data && data.bairros) {
            console.debug('Total de bairros carregados: ' + data.bairros.length)
            observer.next(data.bairros);
          } else {
            console.debug('Total de bairros carregados: 0')
            observer.next([]);
          }
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/bairro.ts